import { forwardRef } from 'react';
import { CardElementProps, CardRef } from '@type/card';


// Card Footer
// ***************************************************************
export const CardFooter = forwardRef<CardRef, CardElementProps>((props, ref) => {
  // destructure props
  const {
    className = '',
    children = 'Card footer',
    ...restProps
  } = props;

  return (
    <div ref={ref} className={className || 'border-t p-3'} {...restProps}>
      { children }
    </div>
  );
});
